import ModalV2 from 'components/Modals/ModalV2/ModalV2'
import { COLORS } from 'design_system/colors'
import { FONT_SIZES } from 'design_system/typography'
import styled from 'styled-components/macro'

export const Container = styled.div`
  ${ModalV2} {
    & > dialog {
      width: 600px !important;
      max-width: 600px;
    }
  }
`

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`

export const ErrorText = styled.span`
  flex: 1;
  color: ${COLORS.powin_red};
  font-size: ${FONT_SIZES.normal};
`

export const Row = styled.div`
  display: flex;
  gap: 1rem;
`

export const Form = styled.form`
  & > * + * {
    margin-top: 1rem;
  }
`

export const Input = styled.input`
  padding: 0 0.5rem;
  // prettier-ignore
  &[aria-invalid="true"] {
    border-color: red;
  }
`
